import get from "lodash/get"
import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import {
  READ,
  READ_SUCCEEDED,
  READ_FAILED,
  CREATE,
  CREATE_SUCCEEDED,
  CREATE_FAILED,
  UPDATE,
  UPDATE_SUCCEEDED,
  UPDATE_FAILED,
  REMOVE,
  REMOVE_SUCCEEDED,
  REMOVE_FAILED,
  CLEAR,
} from "../actions/types"

export const INITIAL_STATE = {
  data: {},
  error: {},
  status: INITIAL,
}

export default function fieldsReducer(state = INITIAL_STATE, action) {
  if (action.type === READ) {
    return {
      ...INITIAL_STATE,
      status: PENDING,
    }
  }

  if (action.type === READ_SUCCEEDED) {
    const fieldsData = action.response.data
    return {
      ...INITIAL_STATE,
      data: fieldsData,
      status: INITIAL,
    }
  }

  if (action.type === READ_FAILED) {
    return {
      ...INITIAL_STATE,
      status: FAILED,
    }
  }
  if (action.type === UPDATE) {
    return {
      ...state,
      status: PENDING,
    }
  }

  if (action.type === UPDATE_SUCCEEDED) {
    const updField = get(action, `response.data`)
    return {
      ...state,
      data: updField,
      error: {},
      status: COMPLETED,
    }
  }

  if (action.type === UPDATE_FAILED) {
    const errorData = get(action, `error.response.data.body`)
    return {
      ...state,
      error: errorData,
      status: FAILED,
    }
  }

  if (action.type === CREATE) {
    return {
      ...state,
      status: PENDING,
    }
  }

  if (action.type === CREATE_SUCCEEDED) {
    const newField = get(action, `response.data`)
    return {
      ...state,
      data: newField,
      error: {},
      status: COMPLETED,
    }
  }

  if (action.type === CREATE_FAILED) {
    const errorData = get(action, `error.response.data.body`)
    return {
      ...state,
      error: errorData,
      status: FAILED,
    }
  }
  if (action.type === REMOVE) {
    return {
      ...INITIAL_STATE,
      status: PENDING,
    }
  }

  if (action.type === REMOVE_SUCCEEDED) {
    return {
      ...INITIAL_STATE,
    }
  }

  if (action.type === REMOVE_FAILED) {
    return {
      ...INITIAL_STATE,
      status: FAILED,
    }
  }

  if (action.type === CLEAR) {
    return {
      ...INITIAL_STATE,
    }
  }
  return state
}
